import type { PageResult } from '@jiaofa/api-types'
import { request } from './request'

export type PointsMallItemType = 'COUPON' | 'PHYSICAL'
export type PointsMallItemStatus = 'ON_SHELF' | 'OFF_SHELF'
export type PointsMallExchangeStatus = 'COMPLETED' | 'PENDING_PICKUP' | 'PICKED_UP' | 'CANCELLED'

export interface AdminPointsMallItem {
  id: string
  type: PointsMallItemType
  name: string
  description?: string
  image?: string
  points: number
  stock: number
  limitPerUser: number
  couponTemplateId?: string
  couponTemplateName?: string
  pickupType?: string
  pickupDesc?: string
  badge?: string
  sort: number
  status: PointsMallItemStatus
  createdAt: string
}

export interface PointsMallItemListParams {
  page?: number
  pageSize?: number
  type?: PointsMallItemType
  status?: PointsMallItemStatus
  keyword?: string
}

export interface PointsMallItemSavePayload {
  id?: string
  type: PointsMallItemType
  name: string
  description?: string
  image?: string
  points: number
  stock?: number
  limitPerUser?: number
  couponTemplateId?: string
  pickupType?: string
  pickupDesc?: string
  badge?: string
  sort?: number
  status?: PointsMallItemStatus
}

export interface AdminPointsMallExchange {
  id: string
  itemId: string
  itemName: string
  type: PointsMallItemType
  pointsCost: number
  couponId?: string
  pickupCode?: string
  pickupRemark?: string
  status: PointsMallExchangeStatus
  nickname?: string
  phone?: string
  createdAt: string
  pickedUpAt?: string
}

export interface PointsMallExchangeListParams {
  page?: number
  pageSize?: number
  type?: PointsMallItemType
  status?: PointsMallExchangeStatus
  keyword?: string
}

export interface PointsMallPickupPayload {
  pickupRemark?: string
}

export const fetchPointsMallItems = async (
  params: PointsMallItemListParams,
): Promise<PageResult<AdminPointsMallItem>> =>
  request<PageResult<AdminPointsMallItem>>({
    url: '/admin/points-mall/items',
    method: 'GET',
    params,
  })

export const createPointsMallItem = async (payload: PointsMallItemSavePayload): Promise<void> =>
  request<void, PointsMallItemSavePayload>({
    url: '/admin/points-mall/items',
    method: 'POST',
    data: payload,
  })

export const updatePointsMallItem = async (payload: PointsMallItemSavePayload): Promise<void> =>
  request<void, PointsMallItemSavePayload>({
    url: '/admin/points-mall/items',
    method: 'PUT',
    data: payload,
  })

export const deletePointsMallItem = async (id: string): Promise<void> =>
  request<void>({
    url: `/admin/points-mall/items/${id}`,
    method: 'DELETE',
  })

export const updatePointsMallItemStatus = async (
  id: string,
  status: PointsMallItemStatus,
): Promise<void> =>
  request<void, { status: PointsMallItemStatus }>({
    url: `/admin/points-mall/items/${id}/status`,
    method: 'PATCH',
    data: { status },
  })

export const fetchPointsMallExchanges = async (
  params: PointsMallExchangeListParams,
): Promise<PageResult<AdminPointsMallExchange>> =>
  request<PageResult<AdminPointsMallExchange>>({
    url: '/admin/points-mall/exchanges',
    method: 'GET',
    params,
  })

export const pickupPointsMallExchange = async (
  id: string,
  payload: PointsMallPickupPayload = {},
): Promise<void> =>
  request<void, PointsMallPickupPayload>({
    url: `/admin/points-mall/exchanges/${id}/pickup`,
    method: 'POST',
    data: payload,
  })
